var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discount"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.05 28.67L3.99667 15.6167V18.2834C3.99667 18.99 4.27667 19.67 4.78334 20.1634L15.17 30.55C16.21 31.59 17.9033 31.59 18.9433 30.55L27.2233 22.27C28.2633 21.23 28.2633 19.5367 27.2233 18.4967L17.05 28.67Z",
    fill: "#323134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.17 23.8834C15.69 24.4034 16.37 24.67 17.05 24.67C17.73 24.67 18.41 24.4034 18.93 23.8834L27.21 15.6034C28.25 14.5634 28.25 12.87 27.21 11.83L16.8233 1.44338C16.33 0.950044 15.65 0.670044 14.9433 0.670044H6.66334C5.19667 0.670044 3.99667 1.87004 3.99667 3.33671V11.6167C3.99667 12.3234 4.27667 13.0034 4.78334 13.4967L15.17 23.8834ZM6.66334 3.33671H14.9433L25.33 13.7234L17.05 22.0034L6.66334 11.6167V3.33671Z",
    fill: "#323134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66334 8.00338C10.5838 8.00338 11.33 7.25719 11.33 6.33671C11.33 5.41624 10.5838 4.67004 9.66334 4.67004C8.74287 4.67004 7.99667 5.41624 7.99667 6.33671C7.99667 7.25719 8.74287 8.00338 9.66334 8.00338Z",
    fill: "#323134"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.10975aaf.svg";
export { ForwardRef as ReactComponent };